import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  TextField,
  Drawer,
  Stack,
  Button,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import { CommonGridToolBarWithFilterText, NewCommonPatientDetails } from '../../../Components/Common Components/CommonComponents';
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { DataGrid } from "@mui/x-data-grid";
import { AmountsCard } from "../../../Components/CommonCards/CommonCards";


const HistoTATReport = () => {
  const datelist = {
    fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    dateIndex: 1,
  }

  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [reportData, setReportData] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [filterData, setfilterData] = useState({
    ...datelist,
    is_outsource: '',
    collected_user_id: '',
    test_done_user_id: '',
    register_user_id: ''
  });
  const [usersList, setUsersList] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  useEffect(() => {
    getUsersList();
    getTATReportData();
  }, []);

  const errorMessage = (msg) => {
    seterrorMsgText(msg);
    seterrorMsg(true);
  }

  const successMessage = (msg) => {
    setsuccessMsgText(msg);
    setsuccessMsg(true);
  }


  const generateUrl = () => {
    let url = `${Serviceurls.HISTOPATHOLOGY_TAT_REPORT}?from_date=${filterData.fromDate}&to_date=${filterData.toDate}`;

    // Add optional parameters if they have values
    if (filterData.is_outsource) {
      url += `&is_outsource=${filterData.is_outsource}`;
    }
    if (filterData.collected_user_id) {
      url += `&collected_user_id=${filterData.collected_user_id}`;
    }
    if (filterData.test_done_user_id) {
      url += `&test_done_user_id=${filterData.test_done_user_id}`;
    }
    if (filterData.register_user_id) {
      url += `&register_user_id=${filterData.register_user_id}`;
    }

    return url;
  }

  const getTATReportData = () => {
    try {
      setisloader(true);
      const url = generateUrl();
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            setReportData(response.data.data || []);
            setisloader(false);
          }
        }).catch(e => {
          setisloader(false);
          if (e?.response?.data?.message) {
            errorMessage(e.response.data.message);
          } else {
            errorMessage(e.message);
          }
        });
    } catch (e) {
      setisloader(false);
      errorMessage(e.message);
    }
  }

  const getReportPrint = () => {
    const url = generateUrl() + "&export_type=pdf";
    try {
      RestAPIService.getAllPrint(url)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message);
        });
    } catch (error) {
      errorMessage(error.message);
    }
  }

  const getUsersList = () => {
    setUsersLoading(true);
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_USER_CONFIGURATION + `?show_all=true`)
        .then((response) => {
          if (response.data.status === 'success') {
            setUsersList(response.data.data || []);
          }
          setUsersLoading(false);
        }).catch(e => {
          setUsersLoading(false);
          errorMessage(e.response.data.message);
        });
    } catch (e) {
      errorMessage(e.response.data.message);
    }
  }


  // Add this function to calculate total TAT
  const calculateTotalTAT = () => {
    if (!reportData || reportData.length === 0) return '0H:0M';

    let totalMinutes = 0;
    let validEntries = 0;

    reportData.forEach(item => {
      const tat = item.actual_tat;
      if (tat && typeof tat === 'string') {
        // Parse TAT format like "0H:0M", "0H:1M", "2H:30M", etc.
        const match = tat.match(/(\d+)H:(\d+)M/);
        if (match) {
          const hours = parseInt(match[1]);
          const minutes = parseInt(match[2]);
          totalMinutes += (hours * 60) + minutes;
          validEntries++;
        }
      }
    });

    if (validEntries === 0) return '0H:0M';

    const avgMinutes = Math.round(totalMinutes / validEntries);
    const hours = Math.floor(avgMinutes / 60);
    const minutes = avgMinutes % 60;

    return `${hours}H:${minutes}M`;
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index });
  }

  const renderFilterScreen = () => {
    return (
      <Box className='eMed_rts_filter_container'>
        <Box className='eMed_filter_Top' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip title="Close">
            <Button onClick={() => { setFilterOpen(false) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={filterData.fromDate}
              ToDate={filterData.toDate}
              DateIndex={filterData.dateIndex}
              SelectedDates={FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>

          {/* <Autocomplete
            size="small"
            options={usersList}
            loading={usersLoading}
            getOptionLabel={(option) => option.user_name || ''}
            value={usersList.find(user => user.id === filterData.register_user_id) || null}
            onChange={(event, newValue) => {
              setfilterData({ ...filterData, register_user_id: newValue?.id || '' });
            }}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Register User" 
                placeholder="Select register user"
              />
            )}
          />

          <Autocomplete
            size="small"
            options={usersList}
            loading={usersLoading}
            getOptionLabel={(option) => option.user_name || ''}
            value={usersList.find(user => user.id === filterData.collected_user_id) || null}
            onChange={(event, newValue) => {
              setfilterData({ ...filterData, collected_user_id: newValue?.id || '' });
            }}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Collected User" 
                placeholder="Select collected user"
              />
            )}
          />

          <Autocomplete
            size="small"
            options={usersList}
            loading={usersLoading}
            getOptionLabel={(option) => option.user_name || ''}
            value={usersList.find(user => user.id === filterData.test_done_user_id) || null}
            onChange={(event, newValue) => {
              setfilterData({ ...filterData, test_done_user_id: newValue?.id || '' });
            }}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Test Done User" 
                placeholder="Select test done user"
              />
            )}
          />
          <Typography fontWeight={600} sx={{ display: 'flex', flexDirection: "row", alignItems: "flex-start", marginLeft: "1vw" }}>{"Test Type"}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', paddingY: '0.5vw' }}>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <RadioGroup
                value={filterData.is_outsource}
                sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                onChange={(e) => {
                  setfilterData({ ...filterData, is_outsource: e.target.value })
                }}
              >
                <FormControlLabel value={""} control={<Radio size='small' />} label="All" />
                <FormControlLabel value={"false"} control={<Radio size='small' />} label="Inhouse" />
                <FormControlLabel value={"true"} control={<Radio size='small' />} label="Outsource" />
              </RadioGroup>
            </FormControl>
          </Box> */}
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText'
              onClick={() => {
                setfilterData({
                  ...datelist,
                  is_outsource: '',
                  collected_user_id: '',
                  test_done_user_id: '',
                  register_user_id: ''
                });
              }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText'
              onClick={() => {
                getTATReportData();
                setFilterOpen(false);
              }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    );
  }

  const closeFilter = () => {
    setFilterOpen(false);
  }

  const tableView = () => {
    const gridToolBar = () => {
      let TextArray = [
        { label: "From Date", value: formatDate(filterData?.fromDate || "") },
        { label: "To Date", value: formatDate(filterData?.toDate || "") },
      ];

      
      if (filterData.register_user_id) {
        const user = usersList.find(u => u.id === filterData.register_user_id);
        TextArray.push({ label: "Register User", value: user?.name || filterData.register_user_id });
      }

      return (
        <Box>
          <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
        </Box>
      );
    }

    // Add serial numbers to data
    const dataWithSno = reportData?.map((item, index) => ({
      ...item,
      sno: (page * pageSize) + index + 1
    })) || [];

    const columns = [
      {
        field: 'patient_name',
        headerName: 'Patient Details',
        flex: 0.15,
        minWidth: 150,
        renderCell: (params) => (<NewCommonPatientDetails disablePhoto={true} data={params?.row} />)
      },
      {
        field: 'sid_number',
        headerName: 'SID Details',
        flex: 0.1,
        minWidth: 120,
        renderCell: (params) => (
          <Box>
            <Typography variant="body2">
              {params.row.sid_number || params.row.sample_id || '-'}
            </Typography>
          </Box>
        )
      },
      {
        field: 'service_name',
        headerName: 'Services',
        flex: 0.15,
        minWidth: 150,
        renderCell: (params) => (
          <Box>
            <Typography variant="body2">
              {params.row.service_name || params.row.test_name || '-'}
            </Typography>
          </Box>
        )
      },
      {
        field: 'sample_received_date',
        headerName: 'Sample Received Date',
        flex: 0.12,
        minWidth: 140,
        renderCell: (params) => (
          <Typography variant="body2">
            {params?.row?.specimen_collected_date ? params?.row?.specimen_collected_date : '-'}
          </Typography>
        )
      },
      {
        field: 'register_user',
        headerName: 'Register User',
        flex: 0.1,
        minWidth: 120,
        renderCell: (params) => (
          <Typography variant="body2">{params?.row?.registered_users || '-'}</Typography>
        )
      },
      {
        field: 'collected_user',
        headerName: 'Collected User',
        flex: 0.1,
        minWidth: 120,
        renderCell: (params) => (
          <Typography variant="body2">{params?.row?.collected_users || '-'}</Typography>
        )
      },
      {
        field: 'test_done_user',
        headerName: 'Test Done User',
        flex: 0.1,
        minWidth: 120,
        renderCell: (params) => (
          <Typography variant="body2">{params?.row?.test_done_users || '-'}</Typography>
        )
      },
      {
        field: 'completed_date_time',
        headerName: 'Completed Date & Time',
        flex: 0.12,
        minWidth: 140,
        renderCell: (params) => (
          <Typography variant="body2">
            {params?.row?.result_completed_date ? params?.row?.result_completed_date : '-'}
          </Typography>
        )
      },
      {
        field: 'actual_tat',
        headerName: 'Actual TAT',
        flex: 0.08,
        minWidth: 100,
        renderCell: (params) => (
          <Typography
            variant="body2"
            fontWeight="bold"
          >
            {params?.row?.actual_tat || '-'}
          </Typography>
        )
      },
    ];

    return (
      <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
        <DataGrid
          rows={dataWithSno}
          columns={columns}
          getRowId={(row) => row.sno}
          page={page}
          pageSize={pageSize}
          rowCount={reportData.length}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { setpage(newPage) }}
          onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          paginationMode="client"
          headerHeight={40}
          density='standard'
          disableSelectionOnClick
          loading={isloader}
        />
      </Box>
    );
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText("");
    setsuccessMsg(false);
    setsuccessMsgText("");
  }

  return (
    <Box sx={{
      height: '79.5vh',
      width: '94vw',
      backgroundColor: Colors.Background,
      padding: '.5vw'
    }}>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
        <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
          {AmountsCard('Avg TAT Time',calculateTotalTAT() , true)}
        </Box>
        <Box>
          <IconButton onClick={() => { setFilterOpen(true) }}>
            <img
              style={{ width: '2vw', height: '2vw' }}
              src={ImagePaths.Filter.default}
              alt='filter'
            />
          </IconButton>
          <IconButton onClick={getReportPrint}>
            <img
              style={{ width: '2vw', height: '2vw' }}
              src={ImagePaths.LabPrintIcon.default}
              alt='print'
            />
          </IconButton>
        </Box>
      </Box>

      <Box>
        {tableView()}
      </Box>

      <Drawer
        anchor={'right'}
        open={filterOpen}
        onClose={closeFilter}
        ModalProps={{ onBackdropClick: closeFilter }}
        sx={{height: '49vw'}}
      >
        {renderFilterScreen()}
      </Drawer>

      {errorMsg &&
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
      }
      {successMsg &&
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
      }
    </Box>
  );
}

export default HistoTATReport;

